import { createAsyncActionTypes } from 'misc/utils';

const PREFIX = 'terms';

export const SEARCH = createAsyncActionTypes(`${PREFIX}/SEARCH`);